'use client';

import React from 'react';
import AppLogo from './AppLogo';

interface PremiumLoaderProps {
  message?: string;
  className?: string;
}

export default function PremiumLoader({ 
  message = "Loading...", 
  className = "" 
}: PremiumLoaderProps) {
  return (
    <div className={`flex flex-col items-center justify-center min-h-[300px] w-full p-8 ${className}`}>
      <div className="relative">
        {/* Outer pulse rings */}
        <div className="absolute -inset-4 bg-blue-500/20 rounded-full animate-ping opacity-25"></div>
        <div className="absolute -inset-8 bg-blue-500/10 rounded-full animate-pulse opacity-20"></div>
        
        {/* Main logo container */}
        <div className="relative bg-white dark:bg-zinc-900 rounded-full p-4 shadow-xl border border-zinc-200 dark:border-zinc-800 z-10">
          <AppLogo size={48} className="animate-pulse" />
        </div>
        
        {/* Spinning border */}
        <div className="absolute -inset-1 border-t-2 border-r-2 border-blue-500 rounded-full animate-spin"></div>
      </div>
      
      {message && (
        <div className="mt-10 flex flex-col items-center">
          <p className="text-sm font-bold tracking-widest text-zinc-900 dark:text-white uppercase opacity-80 animate-pulse">
            {message}
          </p>
          <div className="mt-2 w-24 h-1 bg-zinc-100 dark:bg-zinc-800 rounded-full overflow-hidden">
            <div className="h-full w-full bg-blue-600 animate-shimmer"></div>
          </div>
        </div>
      )}
    </div>
  );
}
